import React, { useEffect, useState } from 'react';
import Statistics from '../../components/statistics/Statistics';
import MemberCondition from '../../components/statistics/MemberCondition';
import MembershipCondition from '../../components/statistics/MembershipCondition';
import StatisticsResult from '../../components/statistics/StatisticsResult';
import DateControl from '../../components/statistics/DateControl';
import moment from 'moment';
import { withRouter } from 'react-router';
import * as searchAPI from '../../lib/api/search';
import * as statisticsAPI from '../../lib/api/statistics';
import * as itemAPI from '../../lib/api/item';
import * as dateControlAPI from '../../lib/api/dateControl';
import { birthToAge, selectMainMembership, selectMainMembershipState, timeValueToDate } from '../../lib/commonFunc/commonFunc';
import { useSelector } from 'react-redux';

const UnifiedStatisticsContainer = ({ history }) => {
  // ==================== Redux 데이터 ====================
  const { club, socketKey } = useSelector(({ club, socket }) => ({
    club: club.defaultClub,
    socketKey: socket.socketKey
  }));

  // ==================== 탭 상태 ====================
  const [activeTab, setActiveTab] = useState('member');

  // ==================== 회원 검색 폼 상태 ====================
  const [memberForm, setMemberForm] = useState({
    startTime: '',
    endTime: moment().format('YYYY-MM-DD'),
    minAge: '',
    maxAge: '',
    gender: 'all',
    type: 'period',
    stateOption: 'registPeriod',
    viewPoint: moment().format('YYYY-MM-DD'),
  });

  // ==================== 회원권 검색 폼 상태 ====================
  const [membershipForm, setMembershipForm] = useState({
    clubItemID: '',
    startTime: moment().subtract(1, 'months').format('YYYY-MM-DD'),
    endTime: moment().format('YYYY-MM-DD'),
    minAge: '',
    maxAge: '',
    gender: 'all',
    viewType: 'period',
    stateOption: '0',
    type: '0',
    viewPoint: moment().format('YYYY-MM-DD'),
  });

  // ==================== 검색 데이터 및 결과 ====================
  const [members, setMembers] = useState([]);
  const [items, setItems] = useState([]);
  const [memberResult, setMemberResult] = useState([]);
  const [membershipResult, setMembershipResult] = useState({ membershipList: [], result: null });
  const [loading, setLoading] = useState(false);

  // ==================== DateControl (상품 일괄 연장) 관련 상태 ====================
  const [dateControlForm, setDateControlForm] = useState({
    productType: 1,
    startTime: moment().format('YYYY-MM-DD'),
    endTime: moment().add(1, 'day').format('YYYY-MM-DD'),
    reason: '',
  });
  const [controlList, setControlList] = useState([]);
  const [dateControlLoading, setDateControlLoading] = useState(false);
  const [controlHistoryOpen, setControlHistoryOpen] = useState(false);

  // ==================== 초기 데이터 로드 ====================
  useEffect(() => {
    if (club && socketKey) initLoad();
  }, [club, socketKey]);

  const initLoad = async () => {
    try {
      setLoading(true);
      const memberRes = await searchAPI.loadClubMemberList({ clubID: club.clubID, page: 0, searchText: '', type: 'allContainMembership', socketKey });

      let members = [];
      if(memberRes.data?.infos) {
        members = memberRes.data.infos.sort((a, b) => (a.registTime > b.registTime ? 1 : -1))
          .map((member) => {
            const age = birthToAge(member.birth);
            const membershipList = memberRes.data.membershipInfos.filter(item => { return item.playerID == member.playerID })
            return {
              ...member,
              age,
              sex:member.sex == 1 ? '남자': '여자',
              membershipList
            };
          })
      }
      console.log('members : ', members);
      setMembers(members);

      const itemRes = await itemAPI.list({ clubID: club.clubID, socketKey });

      setItems(itemRes.data?.infos || []);

      const controlRes = await dateControlAPI.loadAll({ clubID: club.clubID, socketKey });
      console.log('controlRes : ', controlRes);
      setControlList(controlRes.data?.infos || []);
    } catch(e) {
      console.error(e);
    } finally { setLoading(false); }
  }

  // ==================== 탭 관련 핸들러 ====================
  const onChangeTab = (tab) => {
    setActiveTab(tab);
    setMemberResult([]);
    setMembershipResult({ membershipList: [], result: null });
  };

  // ==================== 폼 필드 변경 핸들러 ====================
  const onChangeField = (e) => {
    const { name, value } = e.target;
    
    console.log('onChangeField : ', activeTab, name, value)
    if(activeTab == 'member' && name == 'type' && value == 'viewPoint') {
        setMemberForm(prev => ({ ...prev, ["stateOption"]: 'validViewPoint' }));
    }
    if(activeTab == 'member' && name == 'type' && value == 'period') {
        setMemberForm(prev => ({ ...prev, ["stateOption"]: 'registPeriod' }));
    }
    if(activeTab == 'membership' && name == 'viewType' && value == 'viewPoint') {
        setMembershipForm(prev => ({ ...prev, ["type"]: '0' }));
    }
    if(activeTab == 'membership' && name == 'viewType' && value == 'period') {
        setMembershipForm(prev => ({ ...prev, ["stateOption"]: '0' }));
    }

    if (activeTab === 'membership') setMembershipForm(prev => ({ ...prev, [name]: value }));
    else setMemberForm(prev => ({ ...prev, [name]: value }));
  };

  const onSetPeriod = (unit) => {
    const startTime = (activeTab !== 'membership' && unit === '') ? '' : moment().subtract(1, unit).format('YYYY-MM-DD');
    const endTime = moment().format('YYYY-MM-DD');
    if (activeTab === 'membership') setMembershipForm(prev => ({ ...prev, startTime, endTime }));
    else setMemberForm(prev => ({ ...prev, startTime, endTime }));
  };

  const onSelectMembership = (e) => setMembershipForm(prev => ({ ...prev, clubItemID: e.value }));

  // ==================== 검색 초기화 ====================
  const onInit = () => {
    setMemberForm({
      startTime: moment().subtract(1, 'months').format('YYYY-MM-DD'), endTime: moment().format('YYYY-MM-DD'), minAge: '', maxAge: '', gender: 'all', type: 'period', stateOption: 'registPeriod', viewPoint: moment().format('YYYY-MM-DD')
    });
    setMembershipForm({
      clubItemID: '', startTime: moment().subtract(1, 'months').format('YYYY-MM-DD'), endTime: moment().format('YYYY-MM-DD'), minAge: '', maxAge: '', gender: 'all', viewType: 'period', stateOption: '0', type: '0', viewPoint: moment().format('YYYY-MM-DD')
    });
    setMemberResult([]);
    setMembershipResult({ membershipList: [], result: null });
  };

  // ==================== 검색 실행 ====================
  const onSearch = async () => {
    if (activeTab === 'membership') return await searchMembership();
    return await searchMember();
  };

  // ==================== 회원권 검색 ====================
  const searchMembership = async () => {
    if (!membershipForm.clubItemID) { alert('회원권을 선택해주세요.'); return; }
    try {
      setLoading(true);
      let startTime = 0, endTime = 0, isViewPoint = 0, state = 0;
      if (membershipForm.viewType === 'viewPoint') {
        isViewPoint = 1; 
        startTime = Math.ceil(new Date(membershipForm.viewPoint).setHours(0,0,0,0)/1000); 
        state = Number(membershipForm.type);
      } else {
        startTime = Math.ceil(new Date(membershipForm.startTime).setHours(0,0,0,0)/1000);
        endTime = Math.ceil(new Date(membershipForm.endTime).setHours(23,59,59,0)/1000);
        isViewPoint = 0; 
        state = Number(membershipForm.stateOption);
      }
      const res = await statisticsAPI.loadMembershipList({
        clubID: club.clubID,
        clubItemID: membershipForm.clubItemID,
        state,
        startAge: membershipForm.minAge,
        endAge: membershipForm.maxAge,
        sex: membershipForm.gender === 'all' ? 0 : Number(membershipForm.gender),
        socketKey,
        isViewPoint,
        startTime,
        endTime,
      });

      console.log('res : ', res);
      if (res.data && res.data.result !== 1) { alert('죄송합니다. 해당 기능은 지원하지 않습니다.'); return; }
      setMembershipResult({ membershipList: res.data.infos, result: res.data.result });
    } catch(e) { 
      console.error(e); 
      alert('검색 중 오류가 발생했습니다.'); 
    } finally { 
      setLoading(false); 
    }
  };

  // ==================== 회원 검색 ====================
  const searchMember = async () => {
    const form = memberForm;
    if (moment(form.startTime).isAfter(moment(form.endTime))) { alert('올바른 기간을 입력해 주세요.'); return; }
    if ((form.stateOption === 'expiredInPeriod' || form.stateOption === 'validInPeriod') && form.endTime === '') { alert('유효/만료 회원 기간 검색은 종료일이 반드시 있어야 합니다'); return; }
    
    console.log('members : ', members);
    const stateFilter = members.filter((member) => {
      const { membershipList } = member;
      if (form.type === 'viewPoint') return searchOption[form.stateOption](membershipList, form.viewPoint);
      else if (form.type === 'period') return searchOption[form.stateOption](form.stateOption === 'registPeriod' ? member : membershipList, form.startTime, form.endTime);
      return false;
    });
    const ageFilter = searchOption.age(stateFilter, form.minAge, form.maxAge);
    const sexFilter = searchOption.sex(ageFilter, form.gender);

    const filtered = sexFilter.map(item => {
      let mainMembershipState = '', mainMembership, membershipRegistTime, startTime, endTime, title;
      if (item.membershipList && item.membershipList.length > 0) 
        mainMembership = selectMainMembership(item.membershipList, mainMembershipState, null);
      if (mainMembership) {
        mainMembershipState = selectMainMembershipState(mainMembership, null);
        startTime = timeValueToDate(mainMembership.startTime); 
        endTime = timeValueToDate(mainMembership.endTime); 
        membershipRegistTime = timeValueToDate(mainMembership.registTime); 
        title = mainMembership.title;
      }
      return { ...item, title, state: mainMembershipState, startTime, endTime, membershipRegistTime };
    });
    setMemberResult(filtered);
  };

  // ==================== 회원 클릭 핸들러 ====================
  const onClickMember = (item) => history.push(`/member/@${item.playerID}?clubID=${club.clubID}`);

  // ==================== DateControl (상품 일괄 연장) 관련 핸들러 ====================
  const onSelect = (e) => setDateControlForm(prev => ({ ...prev, productType: e.value }));
  
  const onChangeTimeControlField = (date, key) => setDateControlForm(prev => ({ ...prev, [key]: date }));
  
  const initControl = () => setDateControlForm({ 
    productType: 1, 
    startTime: moment().format('YYYY-MM-DD'), 
    endTime: moment().add(1, 'day').format('YYYY-MM-DD'), 
    reason: '' 
  });

  const onDateControl = async () => {
    if (!club) return;
    const controlStartTime = Math.ceil(new Date(dateControlForm.startTime).setHours(0,0,0,0)/1000);
    const controlEndTime = Math.ceil(new Date(dateControlForm.endTime).setHours(23,59,59,0)/1000);
    if (controlStartTime > controlEndTime) { alert('올바른 날짜를 입력해주세요.'); return; }
    
    // 중복 확인
    for (let i = 0; i < controlList.length; i++) {
      if (!((controlList[i].startTime < controlStartTime && controlList[i].endTime < controlStartTime) || 
            (controlList[i].startTime > controlEndTime && controlList[i].endTime > controlEndTime))) {
        if (controlList[i].sort == 1) { alert('해당 기간에 이미 연장 일자가 존재합니다.'); return; }
        if (dateControlForm.productType == 1 || controlList[i].sort == dateControlForm.productType) { 
          alert('해당 기간에 이미 연장 일자가 존재합니다.'); 
          return; 
        }
      }
    }
    
    try {
      setDateControlLoading(true);
      await dateControlAPI.add({ 
        clubID: club.clubID, 
        socketKey, 
        startTime: controlStartTime, 
        endTime: controlEndTime, 
        registTime: Math.ceil(new Date().getTime()/1000), 
        reason: dateControlForm.reason.length > 0 ? dateControlForm.reason : ' ', 
        sort: dateControlForm.productType 
      });
      const controlRes = await dateControlAPI.loadAll({ clubID: club.clubID, socketKey });
      setControlList(controlRes.data?.infos || []);
      alert('상품 기간을 일괄 연장하였습니다. \n회원권 및 락커 종료일의 기간 반영에는 수 분이 소요될 수 있습니다.');
      setControlHistoryOpen(false);
    } catch (e) { 
      console.error(e); 
      alert('상품 기간 연장 중 오류가 발생했습니다.'); 
    } finally { 
      setDateControlLoading(false); 
    }
  };

  const onUndoControlList = async (id) => {
    if (!club) return;
    try {
      await dateControlAPI.undo({ clubID: club.clubID, controlListID: id, socketKey });
      const controlRes = await dateControlAPI.loadAll({ clubID: club.clubID, socketKey });
      setControlList(controlRes.data?.infos || []);
      alert('연장 기록을 삭제하였습니다. \n상품 기간 반영에는 수 분이 소요될 수 있습니다.');
      initControl();
    } catch (e) { 
      console.error(e); 
    }
  };

  // ==================== 렌더링 ====================
  return (
    <>
      {/* 상품 기간 일괄 연장 */}
      <DateControl
        dateControlForm={dateControlForm}
        onSelect={onSelect}
        onChangeTimeControlField={onChangeTimeControlField}
        onDateControl={onDateControl}
        initControl={initControl}
        controlList={controlList}
        onUndoControlList={onUndoControlList}
        controlHistoryOpen={controlHistoryOpen}
        setControlHistoryOpen={setControlHistoryOpen}
        dateControlLoading={dateControlLoading}
      />

      {/* 탭 + 조건 입력 */}
      <Statistics
        activeTab={activeTab}
        onChangeTab={onChangeTab}
        renderingComponent={
          activeTab === 'member' ? (
            <MemberCondition 
              onChangeField={onChangeField} 
              form={memberForm} 
              onSetPeriod={onSetPeriod} 
              onSearch={onSearch} 
              onInit={onInit} 
            />
          ) : (
            <MembershipCondition 
              onChangeField={onChangeField} 
              form={membershipForm} 
              onSetPeriod={onSetPeriod} 
              items={items} 
              onSelectMembership={onSelectMembership} 
              onSearch={onSearch} 
              onInit={onInit} 
            />
          )
        }
      />

      {/* 검색 결과 */}
      <StatisticsResult
        activeTab={activeTab}
        memberResult={memberResult}
        membershipResult={membershipResult}
        onClickMember={(item) => onClickMember(item)}
        loading={loading}
      />
    </>
  );
};

export default withRouter(UnifiedStatisticsContainer);

// ==================== 검색 옵션 유틸리티 함수 ====================
const searchOption = {
  validViewPoint: function (membershipList, viewPoint) {
    return (
      membershipList.length > 0 &&
      membershipList.some((membership) => {
        let viewPointTime = Math.ceil(new Date(viewPoint).setHours(0, 0, 0, 0) / 1000);
        let startTime = Math.ceil(new Date(membership.startTime * 1000).setHours(0, 0, 0, 0) / 1000);
        let endTime = Math.ceil(new Date(membership.endTime * 1000).setHours(24, 0, 0, 0) / 1000);
        return startTime <= viewPointTime && viewPointTime < endTime;
      })
    );
  },
  expiredViewPoint: function (membershipList, viewPoint) {
    let returnData = [];
    membershipList.length > 0 &&
      membershipList.map((membership) => {
        let viewPointTime = Math.ceil(new Date(viewPoint).setHours(0, 0, 0, 0) / 1000);
        let startTime = Math.ceil(new Date(membership.startTime * 1000).setHours(0, 0, 0, 0) / 1000);
        let endTime = Math.ceil(new Date(membership.endTime * 1000).setHours(24, 0, 0, 0) / 1000);
        if (viewPointTime >= endTime) returnData.push(true); 
        else returnData.push(false);
      });
    return !returnData.includes(false) && membershipList.length > 0;
  },
  waitingViewPoint: function (membershipList, viewPoint) {
    return (
      membershipList.length > 0 &&
      membershipList.some((membership) => {
        let viewPointTime = Math.ceil(new Date(viewPoint).setHours(0, 0, 0, 0) / 1000);
        let startTime = Math.ceil(new Date(membership.startTime * 1000).setHours(0, 0, 0, 0) / 1000);
        return viewPointTime < startTime;
      })
    );
  },
  registPeriod: function (member, startDate, endDate) {
    if (startDate === '' && endDate === '') return true;
    if (startDate === '') return moment(member.registTime).isBefore(moment(endDate).endOf('day'));
    else if (endDate === '') return moment(member.registTime).isAfter(moment(startDate).startOf('day'));
    else {
      let start = Math.ceil(new Date(startDate).setHours(0, 0, 0, 0) / 1000);
      let end = Math.ceil(new Date(endDate).setHours(24, 0, 0, 0) / 1000);
      let registTime = new Date(member.registTime);
      return start <= registTime && registTime < end;
    }
  },
  validInPeriod: function (membershipList, startDate, endDate) {
    if (startDate === '')
      return (
        membershipList.length > 0 &&
        membershipList.some((membership) => {
          return moment(membership.startTime * 1000).isBefore(moment(endDate).endOf('day'));
        })
      );
    return (
      membershipList.length > 0 &&
      membershipList.some((membership) => {
        let viewPointStartTime = Math.ceil(new Date(startDate).setHours(0, 0, 0, 0) / 1000);
        let viewPointEndTime = Math.ceil(new Date(endDate).setHours(24, 0, 0, 0) / 1000);
        let membershipStartTime = Math.ceil(new Date(membership.startTime * 1000).setHours(0, 0, 0, 0) / 1000);
        let membershipEndTime = Math.ceil(new Date(membership.endTime * 1000).setHours(24, 0, 0, 0) / 1000);
        return !((membershipStartTime < viewPointStartTime && membershipEndTime < viewPointStartTime) || 
                 (membershipStartTime > viewPointEndTime && membershipEndTime > viewPointEndTime));
      })
    );
  },
  expiredInPeriod: function (membershipList, startDate, endDate) {
    if (membershipList.length === 0) return false;
    
    let viewPointStartTime = Math.ceil(new Date(startDate).setHours(0, 0, 0, 0) / 1000);
    let viewPointEndTime = Math.ceil(new Date(endDate).setHours(24, 0, 0, 0) / 1000);
    
    if (startDate === '') viewPointStartTime = 0;
    
    // 검색 기간의 끝 시점(endDate의 24시)을 기준으로 모든 회원권이 만료되었는지 확인
    // 유효하거나 대기 중인 회원권이 하나라도 있으면 제외
    const hasActiveOrWaitingMembership = membershipList.some((membership) => {
      let membershipStartTime = Math.ceil(new Date(membership.startTime * 1000).setHours(0, 0, 0, 0) / 1000);
      let membershipEndTime = Math.ceil(new Date(membership.endTime * 1000).setHours(24, 0, 0, 0) / 1000);
      
      // 유효: 검색 기간 끝 시점이 회원권 시작~종료 사이 (아직 만료되지 않음)
      const isValid = membershipStartTime <= viewPointEndTime && viewPointEndTime < membershipEndTime;
      
      // 대기: 회원권 시작 시간이 검색 기간 끝 시점보다 미래 (아직 시작되지 않음)
      const isWaiting = membershipStartTime > viewPointEndTime;
      
      return isValid || isWaiting;
    });
    
    // 검색 기간 끝 시점에 유효하거나 대기 중인 회원권이 있으면 제외 (모두 만료되지 않았음)
    if (hasActiveOrWaitingMembership) return false;
    
    // 검색 기간 내에 만료되는 회원권이 하나라도 있는지 확인
    // (검색 기간 사이에 모든 회원권이 만료된 회원 중, 검색 기간 내에 만료된 회원권이 있는 경우만 포함)
    let hasExpiredInPeriod = false;
    for (let i = 0; i < membershipList.length; i++) {
      let membershipEndTime = Math.ceil(new Date(membershipList[i].endTime * 1000).setHours(24, 0, 0, 0) / 1000);
      // 만료일이 검색 기간 내에 있는지 확인
      if (viewPointStartTime <= membershipEndTime && membershipEndTime <= viewPointEndTime) {
        hasExpiredInPeriod = true;
        break;
      }
    }
    
    return hasExpiredInPeriod;
  },
  age: function (memberList, minAge, maxAge) {
    if (isNaN(minAge) || isNaN(maxAge)) { 
      if (minAge !== '' || maxAge !== '') { alert('나이는 숫자를 입력해 주세요'); } 
      return memberList; 
    }
    if (minAge > maxAge) { alert('올바른 나이를 입력해 주세요'); return []; }
    if (minAge === '' || maxAge === '') return memberList;
    return memberList.filter((member) => member.age >= minAge && member.age <= maxAge);
  },
  sex: function (memberList, val) {
    if (val === 'male') val = '남자';
    if (val === 'female') val = '여자';
    if (val === 'all') return memberList;
    if (memberList && memberList.length > 0) return memberList.filter((member) => member.sex === val);
    else return memberList;
  },
};
